const DEFAULT_MIN_BATCH_SIZE = 1;
const DEFAULT_MAX_BATCH_SIZE = 100;
const DEFAULT_TIME_INTERVAL = 5 * 60 * 1000;
export function getBatchConfiguration(payload = {}) {
  return {
    minBatchSize: payload.minBatchSize || DEFAULT_MIN_BATCH_SIZE,
    maxBatchSize: payload.maxBatchSize || DEFAULT_MAX_BATCH_SIZE,
    autoSendInterval: payload.autoSendInterval || DEFAULT_TIME_INTERVAL
  };
}
//# sourceMappingURL=getBatchConfiguration.js.map